import { useEffect, useState } from "react"
import queryString from "query-string"

import { useCartState, useCartApi } from "shared/cart/context"
import { useProductsState } from "shared/context/products"
import { getDefaultProduct } from "shared/products/helpers"
import { DrugTypeEnum } from "typings/types"

export const parseDrugTypesFromUrl = (): DrugTypeEnum[] => {
  // Example(dev): http://localhost:3001/get-started/your-info?drugType[]=metoclopramide&drugType[]=naproxen
  const drugTypes = queryString.parse(window.location.search)["drugType[]"] as DrugTypeEnum

  if (!drugTypes) {
    return []
  }

  if (!Array.isArray(drugTypes)) {
    return [drugTypes]
  }

  return drugTypes
}

/*
  This hook parses drugType from the query string, adds these products to the cart.

  @returns { boolean }
    - true if PLA products found and are in cart.
    - false if user is in PLA flow but no such product found in DB
    - undefined if user is in regular CYOM flow
*/
export const useProductListingAds = () => {
  const {
    state: { cartItems }
  } = useCartState()
  const { productGroups } = useProductsState()
  const [validPLAProducts, setValidPLAProducts] = useState<Maybe<boolean>>(undefined)
  const { onAddProduct } = useCartApi()

  useEffect(() => {
    if (productGroups.length > 0) {
      const drugTypes = parseDrugTypesFromUrl()

      drugTypes.forEach(drugType => {
        const productGroup = productGroups.find(group => group.drugType === drugType)

        if (productGroup) {
          const product = getDefaultProduct(productGroup)
          setValidPLAProducts(!!product)

          if (product) {
            const productFoundInCart = cartItems.find(p => p.id === product.id)

            /* Add PLA product to cart if it's not there yet */
            if (!productFoundInCart) {
              onAddProduct(product)
            }
          }
        }
      })
    }
  }, [])

  return validPLAProducts
}
